import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { PayrateOverrideContainerComponent } from './payrate-override-container/payrate-override-container.component';
const log = new LoggingService();

export const PayrateOverrideRoute: Ng2StateDeclaration = {
    // name: 'PayrollItem.**'
    name: 'payrateoverride',
    url: '/payrateoverride',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.PayrollItemModule)
    data: { requiresAuth: true },

    component: PayrateOverrideContainerComponent
};
